import isEmailDonationSupported from '../../utils/featureChecks/isEmailDonationSupported';
import { TxpObject } from 'txp-data';
import TxpEntitiesState from 'txp-data/lib/schema/innerSchema/TxpEntitiesState';
import TxpStatus from 'txp-data/lib/schema/TxpStatus';
/**
 * Returns a boolean indicating whether TXP should be shown or not based on
 * TXP entities status and feature checks at the time of execution
 */
export default function shouldHideTxpPanel(txpObject: TxpObject, txpStatus: TxpStatus): boolean {
    if (txpStatus) {
        const { state } = txpStatus;
        const doesStateNeedCardsHidden =
            (!txpObject && state == TxpEntitiesState.Processed) ||
            (state == TxpEntitiesState.ClearedByRecovery ||
                state == TxpEntitiesState.IgnoredByDesign ||
                state == TxpEntitiesState.ProcessedWithNoData ||
                state == TxpEntitiesState.PermanentError);

        if (doesStateNeedCardsHidden) {
            const { isEmailDonationRequested } = txpStatus;
            const isEmailDonationEnabled = isEmailDonationSupported();

            if (
                !isEmailDonationRequested ||
                (isEmailDonationRequested && !isEmailDonationEnabled)
            ) {
                return true;
            }
        }
    }

    return false;
}
